module.exports = __webpack_public_path__ + "img/1.89a87ef0.svg";